import { DatePipe } from '@angular/common';
import {
	Component,
	computed,
	ElementRef,
	Input,
	input,
	ViewChild,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { ExternalAccountModel } from 'src/lib/services/api/external-accounts/external-account.model';
import {
	UserDataGAModel,
	UserDataProfileModel,
	UserDataProgramEnrollmentModel,
	UserDataUserModel,
} from 'src/lib/services/api/users/user-data.model';
import { StringEnumOption } from 'src/lib/utilities/api/patterns/dynamic-fields/string-enum-option.model';
import { IfEmptyPipe } from '../../../../../pipes/if-empty.pipe';
import { SpinWhileDirective } from '../../../../../templates/layout/spin-while/spin-while.directive';

@Component({
	selector: 'ae-profile-account-view',
	templateUrl: './profile-account-view.component.html',
	styleUrls: ['./profile-account-view.component.scss'],
	imports: [DatePipe, IfEmptyPipe, RouterLink, SpinWhileDirective],
})
export class ProfileAccountViewComponent {
	@Input() public profileData: UserDataProfileModel;
	@Input() public loading: boolean;
	@Input() public enableEdit: () => void;
	@Input() public existingPendingChange: boolean;
	@Input() public accountData: UserDataUserModel;
	@Input() public formattedAdminTypeList: StringEnumOption[];
	@Input() public formattedAccessType: string[];
	@Input() public assignedStudents: { name: string; id: number }[];
	@Input() public canViewId: boolean;
	@Input() public canViewLinkedAccounts: boolean = false;
	@Input() public externalAccounts: ExternalAccountModel[];

	@ViewChild('rootElement', { static: true })
	rootElement: ElementRef<HTMLElement>;

	public readonly gaData = input<UserDataGAModel>();
	public readonly programEnrollments = computed(() =>
		[...(this.gaData()?.program_enrollments ?? [])].sort((a, b) =>
			a.title.localeCompare(b.title),
		),
	);

	public isPrimaryProgram = (
		enrollment: UserDataProgramEnrollmentModel,
	): boolean => enrollment.program_id === this.gaData()?.primary_program_id;
}
